<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner">
        <div class="row">
            <div class="col-12 mb-4">
                <div class="title-wrapper">
                    <div>
                        <h1 class="title-default">{{ isEdicao ? 'Editar Variação' : 'Nova Variação' }}</h1>
                        <p class="welcome-message">
                            <button mat-icon-button (click)="voltar()">
                                <mat-icon>arrow_back</mat-icon>
                            </button>
                            Preencha os dados abaixo para {{ isEdicao ? 'editar' : 'cadastrar' }} a variação.
                        </p>
                    </div>
                </div>
            </div>

            @if(isLoading) {
            <div class="col-12">
                <div class="row">
                    <div class="col-md-6">
                        <app-loading-box height="56"></app-loading-box>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 d-flex justify-content-between align-items-center mb-2 mt-2">
                        <app-loading-box width="90" height="24"></app-loading-box>
                        <app-loading-box width="110" height="36"></app-loading-box>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        @for (i of [1, 2, 3]; track i) {
                        <div class="row-wrapper">
                            <div class="row w-100 g-2 align-items-center m-0">
                                <div class="col-10 col-lg-10">
                                    <app-loading-box height="56"></app-loading-box>
                                </div>
                                <div class="col-2 col-lg-2 delete-col produto-grid-delete-col">
                                    <app-loading-box width="40" height="40"></app-loading-box>
                                </div>
                            </div>
                        </div>
                        }
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-12">
                        <app-loading-box height="60"></app-loading-box>
                    </div>
                </div>
            </div>
            } @else {
            <div class="col-12">
                <form [formGroup]="form">
                    <div class="row">
                        <div class="col-md-6">
                            <mat-form-field appearance="outline">
                                <mat-label>Nome</mat-label>
                                <input matInput formControlName="nome" placeholder="Ex: Cor, Tamanho, Voltagem"
                                    required>
                                @if (form.get('nome')?.hasError('required')) {
                                <mat-error>O nome é <strong>obrigatório</strong></mat-error>
                                }
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <app-alert-card type="info" [icon]="'info'" [closable]="false">
                                <span>Os valores destacados com o cadeado
                                    <mat-icon class="material-symbols-outlined">lock</mat-icon>,
                                    estão vinculados a algum produto e desta forma, não podem ser alterados.
                                </span>
                            </app-alert-card>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 d-flex justify-content-between align-items-center mb-2 mt-2">
                            <h4 class="subsection-title mb-0">Descrição</h4>
                            <button mat-button type="button" (click)="addValor()">
                                <mat-icon>add</mat-icon> Adicionar
                            </button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            @for (valor of activeValores; track valor; let i = $index) {
                            <div class="row-wrapper">
                                <div class="row w-100 g-2 align-items-center m-0">
                                    <div class="col-10 col-lg-10">
                                        <mat-form-field appearance="outline">
                                            <input matInput [(ngModel)]="valor.descricao"
                                                [ngModelOptions]="{standalone: true}"
                                                [disabled]="!!valor.possuiProdutos" placeholder="Digite a descrição">
                                            @if (valor.possuiProdutos) {
                                            <mat-icon matSuffix
                                                matTooltip="Este valor está vinculado a um produto e não pode ser alterado"
                                                class="text-secondary cursor-help material-symbols-outlined">lock</mat-icon>
                                            }
                                        </mat-form-field>
                                    </div>
                                    <div class="col-2 col-lg-2 delete-col produto-grid-delete-col">
                                        <button mat-icon-button class="produto-grid-delete-button"
                                            (click)="remove(valor)" type="button" [disabled]="valor.possuiProdutos"
                                            [matTooltip]="valor.possuiProdutos ? 'Este valor está vinculado a um produto' : 'Remover valor'">
                                            <mat-icon class="material-symbols-outlined"
                                                [class]="valor.possuiProdutos ? 'text-muted' : ''">delete</mat-icon>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            }

                            @if (activeValores.length === 0) {
                            <p class="text-secondary" style="font-size: 14px;">Nenhum valor adicionado. Clique em
                                "+ Adicionar" para começar.</p>
                            }
                        </div>
                    </div>
                </form>
            </div>
            }
        </div>
    </div>
</div>

<app-footer-action [isLoadingSalvar]="isSaving" [isSalvarDisabled]="isLoading" (cancelar)="voltar()"
    (salvar)="salvar()"></app-footer-action>